export const columnTypes = {
    TEXT: 'TEXT',
    NUMBER: 'NUMBER'
};
